import { memo } from 'react';

import { MousePointerClickIcon } from '@air/design-icons';

import { MainSideNavItem } from '~/components/v2/components/workspace/main-side-nav/item/MainSideNavItem';
import { useMainSideNavItemSelected } from '~/components/v2/components/workspace/main-side-nav/useMainSideNavItemSelected';
import { Routes } from '~/constants/routes';
import { useTemporaryFeatureFlags } from '~/hooks/useTemporaryFeatureFlags';

export type MainSideNavItemCanvasesProps = {
  pathname: string;
};

export const MainSideNavItemCanvases = memo(({ pathname }: MainSideNavItemCanvasesProps) => {
  const { generativeCanvasEnabled } = useTemporaryFeatureFlags();
  const { isSelected } = useMainSideNavItemSelected({
    isRouteSelected: pathname === Routes.canvases || pathname === Routes.canvas || pathname === Routes.canvasNew,
  });

  if (!generativeCanvasEnabled) {
    return null;
  }

  return (
    <MainSideNavItem
      href={Routes.canvases}
      icon={MousePointerClickIcon}
      id="canvases"
      isSelected={isSelected}
      label="Canvases"
      sidebarInteractionType="canvases"
    />
  );
});

MainSideNavItemCanvases.displayName = 'MainSideNavItemCanvases';
